export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            欢迎联络与投稿
          </h2>
          <p className="mt-2 text-sm text-foreground-600">有任何问题或合作意向，欢迎通过以下方式联系</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-xl p-6 text-center">
            <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-mail-line text-primary-600 text-lg"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-600">bd@6080xinshijue.com</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 text-center">
            <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-copyright-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-1">版权反馈</h3>
            <p className="text-xs text-foreground-600">copyright@6080xinshijue.com</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 text-center">
            <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-edit-2-line text-secondary-600 text-lg"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 mb-1">内容投稿</h3>
            <p className="text-xs text-foreground-600">contribute@6080xinshijue.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}